import { inject, injectable } from 'inversify';
import { army_organisation_group_full } from '@Api';
import { ArmyOrganisationGroup } from '@Models';
import { TYPES } from '@Types';
import { ConstraintMapper } from '@Mapper/ninthAge/constraint.mapper';
import { ConstraintModifierMapper } from '@Mapper/ninthAge/constraint-modifier.mapper';

@injectable()
export class ArmyOrganisationGroupMapper {
  @inject(TYPES.Mapper.ConstraintMapper)
  private _constraintMapper!: ConstraintMapper;
  @inject(TYPES.Mapper.ConstraintModifierMapper)
  private _constraintModifierMapper!: ConstraintModifierMapper;

  public map(item: army_organisation_group_full): ArmyOrganisationGroup {
    return {
      id: item.id,
      name: item.name,
      logo: item.medium_logo,
      organisationId: item.organisation_id,
      position: item.position,
      hidden: item.hidden,
      constraints:
        item.constraints?.map((item) => this._constraintMapper.map(item)) ?? [],
      modifiers:
        item.modifiers?.map((item) =>
          this._constraintModifierMapper.map(item),
        ) ?? [],
    } satisfies ArmyOrganisationGroup as ArmyOrganisationGroup;
  }
}
